import { Adapter } from '../../../interfaces/adapter';
import { Injectable } from '@angular/core';

export class YoutubeCategory {
	private _label: string;
	private _value: string;

	get label(): string {
		return this._label;
	}
	set label(label: string) {
		this._label = label;
	}

	get value(): string {
		return this._value;
	}
	set value(value: string) {
		this._value = value;
	}


	constructor(label: string, value: string) {
		this.label = label;
		this.value = value;
	}
}

@Injectable()
export class YoutubeCategoryAdapter implements Adapter<YoutubeCategory> {
	adapt(item: any): YoutubeCategory {
		return new YoutubeCategory(
			item.snippet.title,
			item.id
		);
	}
}
